import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import PrivateRoute from "../PrivateRoute";
import Login from "../Login";
import Signup from "../Signup";
import Dashboard from "../Dashboard";
import Loyalty from "../Loyalty";
import { connect } from "react-redux";
import Token from "../../helpers/token";
import { getUrl } from "../../constants/constants";

class Root extends Component {
  componentWillMount() {
    console.log("Will mount ---------")
    // let getUrl = (type, user_type) => {
    //   console.log(type, 'type')
    //   console.log(user_type, 'user_type')
    //   switch (type) {
    //     case "retail":
    //       var subUrl = () => {
    //         switch (user_type) {
    //           case "head_office":
    //             return "/dashboard";
    //           case "shell_head_office":
    //             return "/dashboard";
    //           case "helix_head_office":
    //             return "/dashboard/helix";
    //           case "operator":
    //             return "/dashboard/sales";
    //           case "ke_account":
    //             return "/dashboard/ke";                
    //           default:
    //             return "/dashboard/sales";
    //         }
    //       };
    //       return subUrl();
    //     case "operator":
    //       return "/dashboard/sales";
    //     case "helix":
    //       return "/dashboard/helix";
    //     case "restaurant":
    //       return "/dashboard/restaurant";
    //     default:
    //       return "/dashboard/sales";
    //     // default:                 # MODIFY FOR REPORTING #
    //     //   return "/dashboard";
    //   }
    // };

    // if (this.props.location.pathname === "/") {
    //   Token.checkIfValid().then(res => {
    //     this.props.history.replace(getUrl(res.data.type, res.data.user_type));
    //   });
    // }

    if (localStorage.getItem("token")) {
      console.log("++++++++++++++++++++++++++=")
      Token.checkIfValid().then(res => {
        console.log("Check me api response : ",res)
        // if (this.props.location.pathname === "/dashboard/reports") {
          // this.props.history.replace("/dashboard/reports");
        // }
        // else {
          this.props.history.replace(getUrl(res.data.filters.type, res.data.filters.user_type));
        // }
      }).catch(err => {
        localStorage.removeItem("token")
        this.props.history.replace("/login");
      })
    } else {
      this.props.history.replace("/login");
    }
  }

  render() {


    return (
      <main>
        <Switch>
          <Route exact path="/" component={Dashboard} />
          <Route path="/login" component={Login} />
          <Route path="/signup" component={Signup} />
          {/* <Route path ="/loyalty" component ={Loyalty} /> */}
          <PrivateRoute path="/dashboard" component={Dashboard} />
        </Switch>
      </main>
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state
  };
};

export default connect(
  mapStateToProps,
  {}
)(Root);



// WEBPACK FOOTER //
// ./src/containers/Root/index.js